import Box from '@mui/material/Box';
import { createFileRoute } from '@tanstack/react-router';
import useStore, { selectFavoriteCountryId, selectCountryTheme } from '../hooks/client/useStore';
import SearchView from '../features/product-trace/SearchView';

const IndexComponent = () => {
  const selectedCountry = useStore(selectFavoriteCountryId);
  const countryTheme = useStore(selectCountryTheme);

  if (!selectedCountry || !countryTheme) {
    return alert('error');
  }

  return (
    <Box>
      <SearchView />
    </Box>
  );
};

export const Route = createFileRoute('/')({
  component: IndexComponent,
});
